import React, { useState, useRef, useEffect } from 'react';
import { Row, Col, Label, Input, Container } from 'reactstrap';
import CustomSelect from '../../../../Components/Common/CustomSelect';

function FontPicker({ font, idx, fontUploaded, handleSelect, handleDelete }) {
  const [preview, setPreview] = useState(`${font.family}`);
  const [fontType, setFontType] = useState('Normal');
  const [fontThickness, setFontThickness] = useState('400');

  const inputRef = useRef();

  function handleChange(e) {
    setPreview(e.target.value);
  }

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.style.fontFamily = font.family;
      inputRef.current.style.fontWeight = font.weight;
      inputRef.current.style.fontStyle = font.style;
      setFontType((font.style && font.style.charAt(0).toUpperCase() + font.style.slice(1)));
      setFontThickness(font.weight);
      setPreview(`${font.family} ${(font.style && font.style.charAt(0).toUpperCase() + font.style.slice(1))} ${font.weight}`);
    }
  }, [inputRef]);

  return (
    <div className='w-100 d-flex flex-wrap align-items-center px-0 py-2 font-preview-wrapper' key={idx}>
      <Container fluid className='p-0'>
        <Row className='m-0 w-100'>
          <Col xl={2} lg={2} md={2} sm={6}>
            <div className='w-100 d-flex flex-column'>
              <Label>Font Type</Label>
              <CustomSelect
                placeholder='Select Font Type'
                options={[{ value: fontType, name: fontType }]}
                value={fontType}
              />
            </div>
          </Col>
          <Col xl={2} lg={2} md={2} sm={6}>
            <div className='w-100 d-flex flex-column'>
              <Label>Font Thickness</Label>
              <CustomSelect
                placeholder='Selet Font Thickness'
                options={[{ value: fontThickness, name: fontThickness }]}
                value={fontThickness}
              />
            </div>
          </Col>
          <Col xl={8} lg={8} md={8} sm={12}>
            <div className='w-100 d-flex'>
              <div className='w-100 d-flex flex-column'>
                <Label>Preview</Label>
                {/* <Input className='w-100 font-preview-input' type='text' value={preview} onChange={(e) => handleChange(e)} ref={inputRef} /> */}
                <div className='w-100 font-preview-input' contentEditable="true" onChange={(e) => handleChange(e)} ref={inputRef}>{preview}</div>
              </div>
              {fontUploaded ?
                <div className='ms-3 d-flex align-items-center justify-content-center'>
                  <Input className="form-check-input" type="checkbox" onChange={() => handleSelect(font, idx)} />
                  <button className='btn btn-sm text-danger fs-16 ms-1' style={{ paddingTop: '9px' }} onClick={(e) => handleDelete(e, idx)}>
                    <i className='ri-delete-bin-fill'></i>
                  </button>
                </div>
                : null}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default FontPicker;